"use client";

import { useState } from "react";
import { devLabel } from "@/lib/dev-labels";

export interface UrlInputModeProps {
	onAnalyze: (url: string) => void;
}

export function UrlInputMode({ onAnalyze }: UrlInputModeProps) {
	const [url, setUrl] = useState("");
	return (
		<div {...devLabel("11-A2")}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 8,
					background: "rgba(0,0,0,0.35)",
					borderRadius: 6,
					padding: "8px 12px",
					backdropFilter: "blur(8px)",
					position: "relative",
					zIndex: 2,
				}}
			>
				<svg width="14" height="14" viewBox="0 0 24 24" style={{ opacity: 0.7 }} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
					<circle cx="12" cy="12" r="10" />
					<line x1="2" y1="12" x2="22" y2="12" />
					<path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z" />
				</svg>
				<input
					type="url"
					value={url}
					onChange={(e) => setUrl(e.target.value)}
					placeholder="https://www.youtube.com/watch?v=… (TikTok / Vimeo / 등 지원)"
					style={{
						flex: 1,
						background: "transparent",
						border: "none",
						outline: "none",
						color: "#fff",
						fontSize: 13,
						fontWeight: 500,
					}}
					aria-label="YouTube URL"
				/>
				<button
					type="button"
					onClick={() => onAnalyze(url)}
					style={{
						padding: "6px 16px",
						background: "#fff",
						color: "#0a0a0a",
						borderRadius: 5,
						fontWeight: 700,
						fontSize: 12,
						border: "none",
						cursor: "pointer",
						display: "flex",
						alignItems: "center",
						gap: 4,
					}}
				>
					분석 (5코인)
				</button>
			</div>
			<div
				style={{
					fontSize: 9,
					opacity: 0.5,
					marginTop: 4,
					fontFamily: "'Geist Mono',monospace",
				}}
			>
				YouTube / TikTok / Vimeo / Instagram Reels / Twitter / 직접 mp4 link 지원
			</div>
		</div>
	);
}
